import React from 'react'
import Layout from './layout'
import Header from './header'
import Typography from './typography'
import Colors from './colors'

export default function Template() {
  return (
    <Layout>
      <Header />
      <Typography />
      <Colors />
    </Layout>
  )
}
